var _defs, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGxMeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-width: 9px;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #02222b;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke-width: 7px;\n      }\n\n      .st2 {\n        fill: #047290;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.9,6.5h80.2c3.6,0,6.5,3,6.5,6.7v73.7c0,3.7-2.9,6.7-6.5,6.7H9.9c-3.6,0-6.5-3-6.5-6.7V13.1c0-3.7,2.8-6.7,6.5-6.7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 34.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.9,24.3l-19,28.8c-.3.3,0,.7.3.7l18.3-2c.3,0,.7.3.7.7l-7.5,22.9c0,.7.7.7,1,.3l25.2-33.7c.3-.3,0-.7-.3-.7l-19.9,3.3c-.3,0-.7-.3-.7-.7l2.6-19.3c.3-.7-.3-.7-.7-.3h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGxMeter);
export default __webpack_public_path__ + "static/media/gxMeter.0c80e3102b9cbd42a8d8a644a1e05f62.svg";
export { ForwardRef as ReactComponent };